import OrdemServicoService from "@/services/OrdemServicoService";
import { router } from "@/router";
import store from "@/store";
import helper from "@/helper";
import moment from "moment";

export const actions = {
  cadastrarOrdemServico: ({ commit, dispatch }) => {
    commit("setOrdemServico", {
      id: "",
      subtotal: "0,00",
      acrescimo: '0,00',
      desconto: "0,00",
      total: "0,00",
      status: "EM ABERTO",
      cliente_id: "",
      tecnico_id: "",
      telefone: "",
      celular_1: "",
      whatsapp: "",
      cep: "",
      logradouro: "",
      bairro: "",
      estado: "",
      cidade: "",
      numero: "",
      data_inicio: moment().format("YYYY-MM-DD"),
      data_fim: "",
      informacoes_garantia: "",
      observacao: "",
    });

    dispatch("setModalCadastroOrdemServico", true);
  },
  listarOrdemServico: ({ commit }, data) => {
    commit("setOverlay", true);
    OrdemServicoService.listar(data)
      .then((res) => {
        commit("setOrdensServicos", res.data);
        commit("setOverlay", false);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
      });
  },
  visualizarOrdemServico: ({ commit, dispatch, getters }, id) => {
    commit("setOverlay", true);
    OrdemServicoService.visualizar(id)
      .then((res) => {
        commit("setOrdemServico", {
          ...res.data,
          subtotal: helper.formatReal(parseFloat(res.data.subtotal)),
          desconto: helper.formatReal(parseFloat(res.data.desconto)),
          total: helper.formatReal(parseFloat(res.data.total)),
          acrescimo: helper.formatReal(parseFloat(res.data.acrescimo)),
        });

        commit("setOverlay", false);
        dispatch("setModalCadastroOrdemServico", true);
      })
      .catch((e) => {
        console.log(e);
        commit("setOverlay", false);
      });
  },
  salvarOrdemServico: ({ commit, dispatch }, data) => {
    // dispatch("setModalCadastroOrdemServico", false);
    commit("setOverlay", true);
    OrdemServicoService.salvar(data)
      .then((res) => {
        dispatch("listarOrdemServico", {});
        commit("setOverlay", false);
        commit("snackbarSuccess", "OS cadastrada.");
        commit("setOrdemServico", {
          ...store.getters.getOrdemServico,
          id: res.data.id,
        });
      })
      .catch((e) => {
        console.log(e);
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        commit("setOverlay", false);
        commit("snackbarError", "Erro ao cadastrar OS.");
      });
  },
  salvarPagamentoOrdemServico: ({ commit, dispatch, getters }, data) => {
    commit("setOverlay", true);
    OrdemServicoService.pagamento(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("snackbarSuccess", "Pagamento registrado com sucesso.");
        dispatch('setModalPagamentoOrdemServico', false)
        commit('setOrdemServico', {...getters.getOrdemSerico, ...res.data})
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        console.log(e);
        commit("snackbarError", "Erro ao salvar pagamento.");
      });
  },
  atualizarOrdemServico: ({ commit, dispatch }, data) => {
    // dispatch("setModalCadastroOrdemServico", false);
    commit("setOverlay", true);
    OrdemServicoService.atualizar(data)
      .then((res) => {
        dispatch("listarOrdemServico", {});
        commit("setOverlay", false);
        commit("snackbarInfo", "OS atualizada.");
      })
      .catch((e) => {
        if (e.response.status == 422) {
          commit("alertError", e.response.data.errors);
        }
        commit("setOverlay", false);
        console.log(e);
        commit("snackbarError", "Erro ao atualizar OS.");
      });
  },
  excluirOrdemServico: ({ commit, dispatch }, data) => {
    dispatch("setModalCadastroOrdemServico", false);
    commit("setOverlay", false);
    OrdemServicoService.excluir(data)
      .then((res) => {
        // commit("removeOrdemServico", { id: data.id });
        commit("setOverlay", false);
        commit("snackbarError", "OS excluída.");
        dispatch('listarOrdemServico', {limit: 10, page: 1})
      })
      .catch((e) => {
        console.log(e);
        commit("snackbarError", "Erro ao excluir OS.");
      });
  },
  setModalCadastroOrdemServico: ({ commit }, status) => {
    commit("setModalCadastroOrdemServico", false);
    setTimeout(() => {
      commit("setModalCadastroOrdemServico", status);
    }, 100);
  },
  setModalExcluirOrdemServico: ({ commit }, status) => {
    commit("setModalExcluirOrdemServico", false);
    setTimeout(() => {
      commit("setModalExcluirOrdemServico", status);
    }, 100);
  },
  setModalPagamentoOrdemServico: ({ commit }, status) => {
    commit("setModalPagamentoOrdemServico", false);
    setTimeout(() => {
      commit("setModalPagamentoOrdemServico", status);
    }, 100);
  },
  imprimirOrdemServico: ({ commit }, data) => {
    commit("setOverlay", true);
    OrdemServicoService.imprimir(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setModalPrint", res.data.pdf_link);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
      });
  },
  setModalHistoricoStatusOS: ({ commit }, status) => {
    commit("setModalHistoricoStatusOS", false);

    setTimeout(() => {
      commit("setModalHistoricoStatusOS", status);
    }, 100);
  },
  gerarRelatorioPorPeriodoOS: ({ commit, dispatch }, data) => {
    commit("setOverlay", true);
    OrdemServicoService.relatorioPorPeriodo(data)
      .then((res) => {
        commit("setOverlay", false);
        commit("setModalPrint", res.data.pdf_link);
        commit("setOverlay", false);
      })
      .catch((e) => {
        commit("setOverlay", false);
        console.log(e);
        commit("snackbarError", "Erro ao gerar relatório.");
      });
  },
};

export default {};
